<template>
    <div class="bg-white border">
        <simple-hint v-if="!wall.activated" class="border-b">
            {{ $t('notifications.no-bar.body') }}
        </simple-hint>
        <div class="flex flex-row items-center justify-between p-4" :class="wall.activated ? 'border-b' : ''">
            <div class="font-bold text-sm tracking-wide text-black uppercase flex flex-row items-baseline">
                {{ $tc('wall.name', 1) }}
                <div v-if="individual" class="ml-1">
                    <input type="text" v-model="wall.name" class="bg-white font-bold border-b">
                </div>
                <div v-else class="ml-1">{{ wall.name }}</div>
            </div>
            <div class="flex flex-row items-center">
                <toggle v-model="wall.activated"></toggle>
                <div v-if="individual" @click="$emit('remove')" class="ml-4 text-gray-500 text-xl cursor-pointer select-none">x</div>
            </div>
        </div>
        <div v-if="wall.activated && copiableGroups(wall).length > 0" class="border-b flex flex-row items-stretch">
            <div class="p-2 px-4 whitespace-no-wrap text-gray-600">
                {{ $t('wall.just-like') }}
            </div>
            <div
                v-for="otherwalls of copiableGroups(wall)"
                :key="otherwalls[0].name"
                @click="wall.copyFrom(otherwalls[0])"
                class="text-center p-2 px-4 whitespace-no-wrap font-bold border-l select-none w-full flex flex-row items-center justify-center"
                :class="wall.hasSameConfigurationAs(otherwalls[0]) ? 'bg-green-100 text-green-500' : 'text-gray-600 cursor-pointer '"
            >
                <div v-if="wall.hasSameConfigurationAs(otherwalls[0])" class="h-2 w-4 border-b-2 border-l-2 border-green-500 mr-2" :style="{ transform: 'translateY(-.125rem)rotate(-50deg)scale(.9)' }"></div>
                {{ wallsToString(otherwalls) }}
            </div>
        </div>
        <div v-if="wall.activated" class="p-4">
            <field
                :title="$t('wall.length.title')"
                :description="$t('wall.length.description')"
                :help="$t('wall.length.help')" >
                <input type="number" :value="wall.length.toFixed(2)" @change="wall.length = parseFloat($event.target.value) || 0" step="0.01" class="w-auto">
            </field>

          <!-- Leistenunterbrechung -->
<!--            <field-->
<!--                :title="$t('wall.breaks.title')"-->
<!--                :description="$t('wall.breaks.description')"-->
<!--                :help="$t('wall.breaks.help')" class="mt-6">-->
<!--                <input type="number" :value="wall.breaks" @input="wall.breaks = parseInt($event.target.value) || 0" class="w-auto">-->
<!--            </field>-->
            <field
                :title="$t('wall.bar-color.title')"
                :description="$t('wall.bar-color.description')"
                class="mt-6">
                <div>
                <chooser v-model="wall.bar_color" :options="options.bar_color"></chooser>
                <div class="text-xs break text-gray-600">{{ $t('wall.bar-color.note') }}</div>
                </div>
            </field>
            <field
                :title="$t('wall.lighting.title')"
                :description="$t('wall.lighting.description')"
                class="mt-6">
                <chooser v-model="wall.lighted" :options="options.lighting"></chooser>
            </field>
            <div v-if="wall.hasNormalLighting()">
                <simple-hint class="mt-2 -mx-4">
                    {{ $t('wall.central-power-supply.hint') }}
                </simple-hint>
<!--                <WallLightingSettings :wall="wall"></WallLightingSettings>-->
            </div>
        </div>
    </div>
</template>

<script>
import WallLightingSettings from '@/components/WallLightingSettings';
import Field from '@/components/Field'
import Chooser from '@/components/Chooser'
import Toggle from '@/components/Toggle'
import IconInfo from '@/components/icons/Info'
import SimpleHint from '@/components/SimpleHint'
import options from '@/assets/js/options'

import Wall from '@/models/Wall'

export default {
    components: { Field, Chooser, Toggle, IconInfo, SimpleHint },
    data: () => ({
        options
    }),
    props: {
        value: Object,
        individual: Boolean,
        form: Object
    },
    methods: {
        copiableGroups(wall) {
            return Wall.group(this.form.walls.filter(otherwall => otherwall != wall && otherwall.activated && !otherwall.isDefault()))
        },
        wallsToString(walls) {
            return Wall.wallsToLocaleString(walls, this)
        }
    },
    computed: {
        wall() {
            return this.value
        }
    },
}
</script>
